import React, { Suspense } from 'react';
import './Header.css';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Header = ({ balance, tonBalance, onAddBalanceClick, onAddTonClick }) => {
  const { t } = useTranslation();

  return (
    <header className="app-header-nova">
      <div className="header-title-container">
        <h1 className="header-title-nova">{t('header_title')}</h1>
        <img src="/icons/sticker-frog.png" alt="Sticker" className="header-sticker" />
      </div>

      <div className="header-actions">
        <LanguageSwitcher />
        <div className="balance-container stars-container" onClick={onAddBalanceClick}>
          <div className="balance-info">
            <img src="/icons/stars-symbol.png" alt="stars" className="stars-icon" style={{width: 24, height: 24}} />
            <span className="balance-amount">{balance}</span>
          </div>
          <button className="add-balance-btn">+</button>
        </div>
        <div className="balance-container ton-container" onClick={onAddTonClick}>
          <div className="balance-info">
            <img src="/icons/ton_symbol.png" alt="TON" className="ton-icon" />
            <span className="balance-amount">{tonBalance}</span>
          </div>
          <button className="add-balance-btn">+</button>
        </div>
      </div>
    </header>
  );
};

const SuspendedHeader = (props) => (
  <Suspense fallback="Loading...">
    <Header {...props} />
  </Suspense>
);

export default SuspendedHeader; 